import * as React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import "./App.scss";
import AssociatePage from "./AssociatePage";
import CampusPage from "./CampusPage";
import DynCampusPage from "./DynCampusPage";
import CustomerPage from "./CustomerPage";
import QuotePage from "./QuotePage";
import SalesOrderPage from "./SalesOrderPage";
import ProvisionPage from "./ProvisionPage";
import DynProvisionPage from "./DynProvisionPage";
import CustomerListPage from "./CustomerListPage";
import QuoteListPage from "./QuoteListPage";
import SalesOrderListPage from "./SalesOrderListPage";
import ShowMsgFile from "./ShowMsgFile";
import ErrorTest from "./ErrorTest";
import { InteractionStatus, InteractionType, InteractionRequiredAuthError, AuthenticationResult } from "@azure/msal-browser";
import { MsalContext, MsalAuthenticationTemplate, AuthenticatedTemplate } from "@azure/msal-react";
import { loginRequest } from "./authConfig";

interface IAppProps {
}

interface IAppState {
    authState?: AuthenticationResult;
}

export default class App extends React.PureComponent<IAppProps, IAppState> {
    constructor(props: IAppProps) {
        super(props);
        this.state = {};
    }

    static contextType = MsalContext;

    handleLogin = () => {
        if (!this.context?.instance) {
            console.error('MSAL instance not available');
            alert('Authentication service unavailable. Please refresh the page.');
            return;
        }
        this.context.instance.loginPopup(loginRequest).catch((error: Error) => {
            console.error('Login failed:', error);
        });
    };

    handleLogout = () => {
        if (!this.context?.instance) {
            console.error('MSAL instance not available');
            return;
        }
        this.context.instance.logoutPopup().catch((error: Error) => {
            console.error('Logout failed:', error);
        });
    };

    render() {
        const query = new URLSearchParams(window.location.search);
        // const inHubSpot = document.referrer?.indexOf("app.hubspot.com") >= 0;
        let env = document.referrer?.match(/^https:\/\/([^.]+)\.crm\.dynamics\.com\/.*/i)?.[1] || "";
        if (!env) {
            const params = new URLSearchParams(window.location.search);
            env = params.get("env") ?? "";
        }
        //const env = "org0d310dc5";
        //console.log(`ENV=${env}`);
        //console.log(`Referrer=${document.referrer}`);

        return <BrowserRouter>
            <Switch>
                <Route exact path="/auth"><div className="App signin"><span className="spinner"></span></div></Route>
                <Route exact path="/msal"><div className="App signin"><span className="spinner"></span></div></Route>
                <Route exact path="/error-test"><ErrorTest /></Route>
                <Redirect exact from="/" to="/orders" />
                <Route exact path={["/customers", "/quotes", "/orders"]}>
                    <div className="App MenuBar">
                        <nav>
                            <ul className="menu">
                                <li><a href="/"><img src="/testout_logo.png" height="24" alt="Home"></img></a></li>

                                <AuthenticatedTemplate>
                                    <li><a href="https://app.hubspot.com/contacts/3302827/companies" target="hubspot" rel="noreferrer">Companies</a></li>
                                    <li><a href="https://app.hubspot.com/contacts/3302827" target="hubspot" rel="noreferrer">Contacts</a></li>
                                    <li><a href="https://app.hubspot.com/contacts/3302827/deals" target="hubspot" rel="noreferrer">Deals</a></li>
                                    <li><a href="/customers">Customers</a></li>
                                    <li><a href="/quotes">Quotes</a></li>
                                    <li><a href="/orders">Orders</a></li>
                                    <li>
                                        <div tabIndex={0}>Reports and Dashboards</div>
                                        <ul className="sub-menu">
                                            <li><a href="https://reports/dashboard/5PointScaleDashboard.aspx" target="_blank" rel="noreferrer">5-point Scale Dashboard</a></li>
                                            <li><a href="https://apps.testout.com/PowerBIReports/?ReportId=1b06a793-aab7-4461-a323-d143c6fa890e" target="_blank" rel="noreferrer">Sales Performance Dashboard</a></li>
                                            <li><a href="https://apps.testout.com/PowerBIReports/?ReportId=84f8685e-4b95-4f2a-9065-ab66d76a956c" target="_blank" rel="noreferrer">Sales Commission Report</a></li>
                                        </ul>
                                    </li>
                                </AuthenticatedTemplate>
                            </ul>
                            <div className="user">
                                <MsalAuthenticationTemplate
                                    interactionType={InteractionType.Popup}
                                    authenticationRequest={loginRequest}
                                    errorComponent={({ error }) => <>
                                        <span className="icon" title={error ? `Error ${error.errorCode}: ${error.errorMessage}` : "unknown error"}>&#xe001;</span>
                                        <button className="primary" onClick={this.handleLogin}>Sign In</button>
                                    </>}
                                    loadingComponent={() => <div><span className="spinner2"></span></div>}>
                                    <div><span className="icon">&#xe853;</span><span className="name">{this.context?.instance?.getActiveAccount()?.name ?? 'User'}</span></div>
                                    <ul>
                                        {/*<li>Settings</li>*/}
                                        <li onClick={this.handleLogout}>Sign Out</li>
                                    </ul>
                                </MsalAuthenticationTemplate>
                            </div>
                        </nav>
                        <AuthenticatedTemplate>
                            <main>
                                <Route exact path="/customers"><CustomerListPage /></Route>
                                <Route exact path="/quotes"><QuoteListPage /></Route>
                                <Route exact path="/orders"><SalesOrderListPage /></Route>
                                {/*<iframe name="hssales" title="TestOut Sales" src="/orders" frameBorder={0} scrolling="auto"></iframe>*/}
                            </main>
                        </AuthenticatedTemplate>
                    </div>
                </Route>

                <Route path={["/customer", "/quote", "/salesorder", "/provision", "/showMsgFile", "/campus", "/associate", "/dynamics"]}>
                    <MsalAuthenticationTemplate
                        interactionType={InteractionType.Popup}
                        authenticationRequest={loginRequest}
                        errorComponent={({ error }) => <div className="App signin">
                            <span className="icon">&#xe001;</span>
                            <p>{error ? `Error ${error.errorCode}: ${error.errorMessage}` : "unknown error"}</p>
                            <button className="primary" onClick={this.handleLogin}>Sign In</button>
                        </div>}
                        loadingComponent={() => <div className="App signin"><span className="spinner"></span></div>}>

                        {/* HubSpot Pages */}

                        <Route exact path="/customer/:customerNumber" render={({ match }) =>
                            <div className="App"><CustomerPage customerNumber={match.params.customerNumber} /></div>
                        } />
                        <Route exact path="/customer">
                            <div className="App"><CustomerPage companyId={query.get("companyId") ?? undefined} /></div>
                        </Route>
                        <Route exact path="/campus">
                            <div className="App"><CampusPage companyId={query.get("companyId") ?? undefined} /></div>
                        </Route>
                        <Route path="/provision/deal">
                            <div className="App"><ProvisionPage objectId={query.get("dealId") ?? undefined} objectType={"Deal"} /></div>
                        </Route>
                        <Route path="/provision/company">
                            <div className="App"><ProvisionPage objectId={query.get("companyId") ?? undefined} objectType={"Company"} /></div>
                        </Route>
                        <Route path="/provision/contact">
                            <div className="App"><ProvisionPage objectId={query.get("contactId") ?? undefined} objectType={"Contact"} /></div>
                        </Route>
                        <Route path="/quote">
                            <div className="App"><QuotePage /></div>
                        </Route>
                        <Route path="/salesorder">
                            <div className="App"><SalesOrderPage /></div>
                        </Route>
                        <Route exact path="/associate">
                            <div className="App">
                                <AssociatePage dealId={query.get("dealId") ?? undefined} type={query.get("type") ?? "order"} 
                                               dealname={query.get("name") ?? undefined} />
                            </div>
                        </Route>
                        <Route path="/showMsgFile">
                            <ShowMsgFile quoteDocumentId={query.get("quoteDocumentId") ?? undefined} orderDocumentId={query.get("orderDocumentId") ?? undefined} />
                        </Route>

                        {/* Dynamics 365 Pages */}

                        <Route exact path="/dynamics/campus">
                            <div className="App"><DynCampusPage entityId={query.get("entityId") ?? undefined} entityType={query.get("entityType") ?? undefined} env={env} /></div>
                        </Route>
                        <Route path="/dynamics/provision/deal">
                            <div className="App"><DynProvisionPage objectId={query.get("opportunityId") ?? undefined} objectType={"Opportunity"} env={env} /></div>
                        </Route>
                        <Route path="/dynamics/provision/account">
                            <div className="App"><DynProvisionPage objectId={query.get("accountId") ?? undefined} objectType={"Account"} env={env} /></div>
                        </Route>
                        <Route path="/dynamics/provision/contact">
                            <div className="App"><DynProvisionPage objectId={query.get("contactId") ?? undefined} objectType={"Contact"} env={env} /></div>
                        </Route>

                    </MsalAuthenticationTemplate>
                </Route>
            </Switch>
        </BrowserRouter>;
    }
}